import { Component, inject } from '@angular/core';
import { InternetConnectionService } from '../../../../core/services/internet-connection.service';
import { LanguageService } from '../../../../core/services/language.service';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-internet-status',
  templateUrl: './internet-status.component.html',
  imports: [AsyncPipe],
})
export class InternetStatusComponent {
  internetConnectionService = inject(InternetConnectionService);
  languageService = inject(LanguageService);

  constructor() {}
}
